var _radialGradient, _path, _defs, _clipPath, _radialGradient2, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoImageRect(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 175,
    cy: 175,
    r: 250.3336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3605,
    stopColor: "#e9e9e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e6e6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M0 0h350v350H0z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M154.4 151.7l-42-51.4v51.4h-10v-70h7l42 51.4V81.7h10v70h-7zm33.1-55c-4.9 5.2-7.3 11.6-7.3 19.3 0 7.8 2.4 14.2 7.3 19.3 4.9 5.1 10.9 7.7 18.2 7.7 7.3 0 13.3-2.6 18.2-7.7 4.9-5.1 7.3-11.6 7.3-19.3 0-7.7-2.4-14.1-7.3-19.3-4.9-5.2-10.9-7.8-18.2-7.8-7.3 0-13.4 2.6-18.2 7.8zm-7.3 45.4c-6.8-7-10.3-15.8-10.3-26.2 0-10.4 3.4-19.1 10.3-26.2 6.8-7 15.3-10.6 25.5-10.6 10.1 0 18.6 3.5 25.5 10.6 6.8 7 10.2 15.8 10.2 26.2 0 10.4-3.4 19.1-10.2 26.2-6.8 7-15.3 10.5-25.5 10.5-10.1.1-18.6-3.4-25.5-10.5zM42 250.7v-70h10v70H42zm78 0v-47.1l-20.5 32.1h-7L72 203.6v47.1H62v-70h7l27 42.7 27-42.7h7v70h-10zm35.2-27.5h21.6l-10.8-26-10.8 26zm32.9 27.5l-7.4-18h-29.5l-7.3 18h-10.4l29-70h7l29 70h-10.4zm79.9 0v-70h40v9.5h-30v18h23v9.5h-23v23.5h31v9.5h-41zm-62.7-9.3c-6.9-6.8-10.3-15.4-10.3-25.7 0-10.1 3.4-18.7 10.1-25.6 6.8-6.9 15.2-10.4 25.3-10.4 5 0 9.8 1 14.2 2.9 4.5 1.9 8.3 4.5 11.3 7.9l-6.7 6.6c-2.1-2.3-4.9-4.2-8.3-5.7-3.4-1.5-6.9-2.2-10.6-2.2-7.2 0-13.3 2.5-18.1 7.6-4.9 5.1-7.3 11.4-7.3 18.9 0 7.8 2.5 14.2 7.5 19.1 5 4.9 11.3 7.4 18.8 7.4 7.1 0 12.9-2.2 17.2-6.5v-18h-20v-9.5h30v30.5c-3.1 3.9-7 7-12 9.4-4.9 2.4-10 3.6-15.3 3.6-10.3 0-18.9-3.4-25.8-10.3z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#b"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(253.877 .2128 .2128 -253.877 173 174)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dadada"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M-2-1h350v350H-2z",
    clipPath: "url(#d)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d1d1b",
    d: "M348 349v-.5H-1.5V-.5h349V349h.5v-.5.5h.5V-1.5h-351v351h351v-.5z",
    clipPath: "url(#d)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImageRect);
export default __webpack_public_path__ + "static/media/NoImageRect.3067523357a930eddb5ba7132a49da6a.svg";
export { ForwardRef as ReactComponent };